document.addEventListener('DOMContentLoaded', () => {
    const words = document.querySelectorAll('.word');
    gsap.registerPlugin(CustomEase);
    let tl = gsap.timeline({ repeat: -1 });

    // Fonction d'ease personnalisée pour un seul rebond
    const singleBounce = CustomEase.create("custom", "M0,0 C0.14,0 0.242,0.438 0.272,0.561 0.313,0.728 0.354,0.963 0.362,1 0.37,0.985 0.414,0.96 0.455,0.898 0.51,0.813 0.587,0.891 0.6,0.9 0.676,0.95 0.719,0.981 0.726,0.998 0.948,0.998 1,1 1,1 ");

    words.forEach((word, index) => {
        tl.fromTo(word,
            {
                y: 50,     // Commence en dessous de sa position finale
                opacity: 0  // Commence invisible
            },
            {
                y: 0,         // Arrive à sa place
                opacity: 1,   // Devient visible
                duration: 0.8,  // Durée de l'animation d'entrée
                ease: singleBounce // Effet de rebond unique
            }
        )
        .to(word, {
            duration: 1.5, // Temps d'affichage
        })
        .to(word, {
            y: -50,       // Monte vers le haut
            opacity: 0,   // Disparaît
            duration: 1,
            ease: "power2.in"
        }, "+=0.2"); // Petit délai avant de repartir
    });

    gsap.to('.first-word', {
        '--pseudo-width': '100%',
        duration: 1,
        ease: 'power2.out',
        delay: 1
    });
});